import React, { useContext } from "react"
import * as styles from "../../personal.module.css"
import Button from "src/components/core/atoms/button"
import { UserContext } from "src/context/UserContext"

export const CompleteSignInForm = () => {
  const { signIn } = useContext( UserContext )

  const doSignIn = ( e ) => {
    const email = e.currentTarget.parentElement.querySelector( '[name="email"]' ).value
    const password = e.currentTarget.parentElement.querySelector( '[name="password"]' ).value
    signIn( { email, password }, "/services/booking" )
  }

  return (
    <>
      <div className={ styles.innerContainer }>
        <div className={ styles.inputContainer }>
          <p>Password*</p>
          <input
            type="password"
            className={ styles.inputBox }
            name="password" />
          <p name="password" component="div" />
        </div>
      </div>
      <Button onClick={ doSignIn } type="button" variant="solid">
        Login
      </Button>
    </>
  )
}

export default CompleteSignInForm